var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlogSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3{fill:#00a0df;}.cls-2{fill:#fff;}.cls-3{stroke:#fff;stroke-miterlimit:10;stroke-width:50px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_141",
    "data-name": "Layer 141"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 300,
    cy: 300,
    r: 299.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 111.29,
    y: 298.98,
    width: 311.15,
    height: 69.15,
    rx: 34.58,
    transform: "translate(-157.7 286.4) rotate(-45)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 343.08,
    cy: 254.48,
    r: 106.54
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlogSearch);
export default __webpack_public_path__ + "static/media/blog_search.04f819b70c186428ad072bd7c6c93717.svg";
export { ForwardRef as ReactComponent };